import type { IMaskFunction } from 'interfaces/IMask';
import padStart from 'lodash/padStart';

const percent: IMaskFunction = {
  apply: (value: number | string) => {
    if (value === null || value === undefined || value === '') return '';
    return (
      '% ' +
      new Intl.NumberFormat('pt-BR', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Math.min(Number(value), 100) || 0)
    );
  },
  clean: value => {
    value = (value || '').toString().replace(/[^\d,]/gi, '');

    if (!value.includes(',')) {
      value = '0,' + padStart(value, 2, '0');
    }

    const [, fractions] = value.split(',');

    if (fractions && fractions.length !== 2) {
      value = value
        .replace(',', '')
        .replace(/(\d+)?(\d{2})/gi, '$1,$2')
        .replace(/^,/gi, '0,');
    }

    return Math.min(parseFloat(value.replace(/\./gi, '').replace(',', '.')), 100.0);
  }
};

export default percent;
